import gql from 'graphql-tag'

export const LIST_CUSTOM_ORDER_WEBHOOKS = gql`
  query ListCustomOrderWebhooks {
    listCustomOrderWebhooks {
      id
      name
      url
      headers {
        key
        value
      }
      enabled
      includeComposerOrders
      autoDisabledAt
      lastFailureReason
    }
  }
`

export const CREATE_CUSTOM_ORDER_WEBHOOK = gql`
  mutation CreateCustomOrderWebhook(
    $name: String!
    $url: String!
    $headers: [WebhookHeaderInput!]
    $includeComposerOrders: Boolean
  ) {
    createCustomOrderWebhook(
      name: $name
      url: $url
      headers: $headers
      includeComposerOrders: $includeComposerOrders
    ) {
      id
      name
      url
      headers {
        key
        value
      }
      enabled
      includeComposerOrders
      autoDisabledAt
      lastFailureReason
    }
  }
`

export const UPDATE_CUSTOM_ORDER_WEBHOOK = gql`
  mutation UpdateCustomOrderWebhook(
    $id: uuid!
    $name: String
    $url: String
    $enabled: Boolean
    $headers: [WebhookHeaderInput!]
    $includeComposerOrders: Boolean
  ) {
    updateCustomOrderWebhook(
      id: $id
      name: $name
      url: $url
      enabled: $enabled
      headers: $headers
      includeComposerOrders: $includeComposerOrders
    ) {
      id
      name
      url
      headers {
        key
        value
      }
      enabled
      includeComposerOrders
      autoDisabledAt
      lastFailureReason
    }
  }
`

export const DELETE_CUSTOM_ORDER_WEBHOOK = gql`
  mutation DeleteCustomOrderWebhook($id: uuid!) {
    deleteCustomOrderWebhook(id: $id)
  }
`
